export default __webpack_public_path__ + "static/media/copy_icon.e668f9b0.svg";